import angular from 'angular'
import Navbar from './navbar/navbar'
import User from './user/user'
import Auth from './auth/auth'
import Store from './storage'
import Modal from './ui/modal'
import ConfirmSupervisor from './ui/confirmSupervisor/confirmSurpervisor.component'
import StripPrefixModule from './strip-prefix'
import TimePickerModule from './ui/time-picker'
import AllowOnlyScanModule from './allow-only-scan'
import ConnectionStatusModule from './connection-status/'
import DataCounter from './data-counter'
import Branch from './branch'
import DateUtil from './date-util'
import StripWhiteSpaceModule from './strip-whitespace'
import SearchAndSelectModule from './search-and-select'
import Sound from './sound'
import ChangePassword from './ui/changePassword/changePassword.component'
import TimeoutCountdown from './ui/timeoutCountdown/timeoutCountdown.component'
import AutoCapitalizeModule from './auto-capitalize'
import ConfigsModule from './configs'
import Navigation from './navigation'
import TimezoneModule from './timezone-list'
import InputFile from './file-upload'
import StreamPrintLogo from './stream-print-logo'
import StreamCompanyLogo from './stream-company-logo'
import DisableCopyPaste from './disable-copy-paste'
import PaginatedSearchAndSelectModule from './paginated-search-and-select'
import DisableTrackingIdTyping from './disable-tracking-id-typing'
import FetchReactData from './fetch-react-data'
import DndFixModule from './dnd-fix'
import DenomIconDirective from './denom-icon/denom-icon.directive'
import './denom-icon/denom-icon.scss'
import SearchAutofocusDirective from './search-autofocus/search-autofocus.directive'

let commonModule = angular.module('app.common', [
    User,
    Auth,
    Store,
    Navbar,
    Modal,
    StripPrefixModule,
    TimePickerModule,
    AllowOnlyScanModule,
    ConnectionStatusModule,
    DataCounter,
    Branch,
    DateUtil,
    StripWhiteSpaceModule,
    SearchAndSelectModule,
    Sound,
    AutoCapitalizeModule,
    ConfigsModule,
    Navigation,
    TimezoneModule,
    InputFile,
    StreamPrintLogo,
    StreamCompanyLogo,
    DisableCopyPaste,
    PaginatedSearchAndSelectModule,
    DisableTrackingIdTyping,
    FetchReactData,
    DndFixModule
])
    .component('confirmSupervisor', ConfirmSupervisor)
    .component('changePassword', ChangePassword)
    .component('timeoutCountdown', TimeoutCountdown)
    .directive('denomIcon', DenomIconDirective)
    .directive('searchAutofocus', SearchAutofocusDirective)
    .name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/index.js